import type { AuthenticatedRequest} from '@app/rest/rest.lib';
import { authenticatedRequest } from '@app/rest/rest.lib'
import type { IApiVisit } from '@app/state/visits/helpers'

import type { IApiPatient, IApiNewPatient, IApiUpdatePatient } from './helpers'

export interface PatientListResponse {
  patients: IApiPatient[]
}

export function getAllPatients() {
  return authenticatedRequest<PatientListResponse>({
    method: 'get',
    url: '/api/v2/patients',
  })
}

export interface PatientResponse {
  patient: IApiPatient
}

export function getPatientById(id: string) {
  return authenticatedRequest<PatientResponse>({
    method: 'get',
    url: `/api/v2/patient/${id}`,
  })
}

export function findPatientByMRN(mrn: string) {
  return authenticatedRequest<PatientResponse>({
    method: 'get',
    url: `/api/v2/patient/mrn/${mrn}`,
  })
}

export interface PatientVisitListResponse {
  visits: IApiVisit[]
}

export interface CreatePatientResponse {
  patient: IApiPatient
}

export function createPatient(patient: IApiNewPatient) {
  return authenticatedRequest<CreatePatientResponse>({
    method: 'post',
    url: `/api/v2/patient`,
    data: patient,
  })
}

export interface UpdatePatientResponse {
  patient: IApiPatient
}

export function updatePatient(
  id: string,
  patient: IApiUpdatePatient,
): AuthenticatedRequest<UpdatePatientResponse> {
  return authenticatedRequest({
    method: 'post',
    url: `/api/v2/patient/${id}`,
    data: patient,
  })
}

export interface AddContactInformationResponse {
  status: string
}

export function addContactInformationToPatient(
  patientId: string,
  emailAddress: string,
  phoneNumber: string,
  phoneNumberType: string,
) {
  return authenticatedRequest<AddContactInformationResponse>({
    method: 'post',
    url: `/clinical-admin/patient/add-contact-information`,
    data: {
      patientId,
      emailAddress,
      phoneNumber,
      phoneNumberType,
    },
  })
}

export interface UpdateContactInformationResponse {
  patient: IApiPatient
}

export function updatePatientContactInformation(
  patientId: string,
  emailAddress: string,
  phoneNumber: string,
  phoneNumberType: string,
): AuthenticatedRequest<UpdateContactInformationResponse> {
  return authenticatedRequest({
    method: 'post',
    url: `/clinical-admin/patient/edit-contact-information`,
    data: {
      patientId,
      emailAddress,
      phoneNumber,
      phoneNumberType,
    },
  })
}
